<!-- Home Copyright 2022 Rebecca L Beaudet -->
<script lang="ts">
  import Featurette from '../Content/Featurette.svelte';
  import Carousel from '../Navigation/Carousel.svelte';
</script>

<Carousel />
<!-- Marketing messaging and featurettes
================================================== -->
<!-- Wrap the rest of the page in another container to center all the content. -->
<div class="container marketing">
  <Featurette />
</div>
